module.exports = __webpack_public_path__ + "static/img/htjs1.8b2118a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/htjs1.png
// module id = 9Jfl
// module chunks = 1